export const shouldDisplayPlaceholder = (labelOption, size, label) => Boolean(!label || (labelOption === 'sticky' && !isSmallTextFieldSizes(size)));
export const isSmallTextFieldSizes = (size) => [40, 32, 24].includes(size);
